import * as S from '@effect/schema/Schema';
export var RewardsPageBlockConfig = S.struct({
  typename: S.literal('RewardsPageBlock'),
  id: S.string,
  hash: S.string
});